module.exports = __webpack_public_path__ + "u12.no2.774442ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u12.no2.jpg
// module id = miy5
// module chunks = 0